import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
  Radio,
  RadioGroup,
  TranslationProvider,
  utils,
} from '@resy/ui-kitchen';

import './GratuityButtons.scss';

class GratuityButtons extends React.Component {
  static propTypes = {
    currencyCode: PropTypes.string,
    handleGratuityChange: PropTypes.func,
    locale: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string,
      amount: PropTypes.string,
    }).isRequired),
    selected: PropTypes.shape({
      value: PropTypes.string,
      amount: PropTypes.string,
    }),
    labeledBy: PropTypes.string.isRequired,
    isUSLocation: PropTypes.bool,
  }

  static defaultProps = {
    currencyCode: undefined,
    handleGratuityChange: () => {},
    locale: undefined,
    options: [],
    selected: undefined,
    isUSLocation: false,
  }

  state = {
    /* eslint-disable-next-line react/destructuring-assignment */
    selected: this.props.selected,
  }

  getAmount = (amount) => {
    const {
      currencyCode, locale,
    } = this.props;

    return utils.getFormattedPrice(amount, currencyCode, '$', locale);
  }

  // does not take the event, just the value eg {value:String, amount:Number}
  onChange = (val) => {
    const { selected } = this.state;
    if (selected && selected.value !== val.value) {
      const { handleGratuityChange } = this.props;
      this.setState({ selected: val });
      handleGratuityChange(val);
    }
  }

  renderNoneOption = (option) => {
    const { selected } = this.state;

    return (
      <Radio
        data-test-id={`gratuity-button-${option.value}`}
        key={option.value}
        checked={selected?.amount === option.amount}
        className={cx('Radio__none', { active: selected?.amount === option.amount })}
        value={option}
      >
        <TranslationProvider translationKey="none">
          <div className="GratuityButtons__none">
            None
          </div>
        </TranslationProvider>
      </Radio>
    );
  }

  getSorted = (options) => {
    let optionsArranged;
    let zero;
    for (let i = 0; i < options.length; i += 1) {
      if (options[i].amount === 0) {
        zero = i;
        break;
      }
    }
    if (zero !== undefined) {
      optionsArranged = options.filter(
        (opt) => opt.amount !== 0
      );
      optionsArranged.push(options[zero]);
    }
    return optionsArranged || options;
  }

  render() {
    const { labeledBy, options, isUSLocation } = this.props;
    const { selected } = this.state;

    if (options.length === 1 && !options[0].amount) {
      return null;
    }

    return (
      <>
        <RadioGroup className="GratuityButtons" onChange={this.onChange} aria-labelledby={labeledBy}>
          {this.getSorted(options).map((option) => {
            if (option.amount === 0) {
              return this.renderNoneOption(option);
            }
            return (
              <Radio
                data-test-id={`gratuity-button-${option.value}`}
                key={option.value}
                checked={selected?.amount === option.amount}
                className={cx({ active: selected?.amount === option.amount })}
                value={option}
              >
                <div className="GratuityButtons__percent">
                  {option.value}
                </div>
                <div className="GratuityButtons__total-cost">{this.getAmount(option.amount)}</div>
              </Radio>
            );
          })}
        </RadioGroup>
        {isUSLocation && (
          <div className="OrderSummary__section--body__row">
            <TranslationProvider translationKey="gratuity_disclaimer">
              <div className="OrderSummary__disclaimer">Gratuity is applied pre-tax.</div>
            </TranslationProvider>
          </div>
        )}
      </>
    );
  }
}

GratuityButtons.displayName = 'GratuityButtons';
export default GratuityButtons;
